<template>
    <svg class="home-page__svg" width="1000" height="450" viewBox="0 0 1000 450" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 88 h20 l16 16 v160 h280" stroke="#00A4FF" stroke-width="2"/>

        <circle cx="400" cy="265" r="130" fill="#00A4FF" stroke="#00A4FF"/>
    </svg>
</template>
